import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Select,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { postAPI, displayMessage } from "../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../constants/messages";
import { KITCHEN_ITEM_CREATE } from "../../constants/api";
import { ITEM_UNITS } from "../../constants/constent";

function KitchenItemAdd() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const createData = (values) => {
    setLoading(true);

    const successFn = (res) => {
      if (res.status === true) {
        displayMessage(SUCCESS_MESSAGE, res.message);
        navigate("/kitchen/item");
      } else {
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to save item");
    };

    postAPI(KITCHEN_ITEM_CREATE, values, successFn, errorFn);
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Add Item"
          bordered={false}
          extra={
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={createData}>
              <Row gutter={[16, 16]}>
                <Col span={10}>
                  <Form.Item
                    name="name"
                    label="Item Name"
                    rules={[
                      { required: true, message: "Item name is required" },
                    ]}
                  >
                    <Input placeholder="Item name" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name="unit"
                    label="Unit"
                    rules={[{ required: true, message: "Unit is required" }]}
                  >
                    <Select placeholder="Select unit">
                      {ITEM_UNITS.map((unit) => (
                        <Select.Option key={unit.value} value={unit.value}>
                          {unit.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name="reorder_level"
                    label="Low Stock Alert"
                    rules={[
                      {
                        required: true,
                        message: "Low-stock alert is required",
                      },
                    ]}
                  >
                    <Input type="number" placeholder="0" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name="expiry_alert_days"
                    label="Expiry alert days"
                    rules={[
                      {
                        required: true,
                        message: "Expiry alert days is required",
                      },
                    ]}
                  >
                    <Input type="number" placeholder="2" />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item name="remark" label="Remark">
                    <Input placeholder="Optional remark" />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item style={{ float: "right" }}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Submit
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenItemAdd;
